import { css, styled } from 'styled-components';

import { COLORS, RETAILER_COLORS } from '@components/web/src/styles';

export const DiscoveryQuizAnswersItemContainer = styled.button<{
  $selectedAnswerSelector: string;
  $notSelectedAnswerSelector: string;
  $isCorrectAnswer: boolean;
  $isSelectedAnswer: boolean;
}>`
  all: unset;
  box-sizing: border-box;
  display: flex;
  gap: 4px;
  justify-content: left;
  width: 100%;
  height: fit-content;
  padding: 8px;
  color: ${RETAILER_COLORS.primary['700']};
  background-color: ${COLORS.base.white};
  border: 1px solid ${RETAILER_COLORS.primary['300']};
  cursor: pointer;
  &:first-child {
    border-bottom: 0.5px solid ${RETAILER_COLORS.primary['300']};
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-top: 0.5px solid ${RETAILER_COLORS.primary['300']};
    border-radius: 0 0 8px 8px;
  }
  ${({ $isSelectedAnswer }) =>
    $isSelectedAnswer &&
    css`
      cursor: not-allowed;
    `}

  ${({ $selectedAnswerSelector }) => {
    if ($selectedAnswerSelector === 'isSelectedTrue')
      return css`
        color: ${COLORS.base.white};
        background-color: ${COLORS.base.green};
        border: 1px solid ${COLORS.base.green};
        transition: all 300ms cubic-bezier(0.08, 0.82, 0.17, 1);
      `;

    if ($selectedAnswerSelector === 'isSelectedFalse')
      return css`
        color: ${COLORS.base.white};
        background-color: ${COLORS.error[600]};
        border: 1px solid ${COLORS.error[600]};
        transition: all 300ms cubic-bezier(0.08, 0.82, 0.17, 1);
      `;
    return css``;
  }}
  ${({ $notSelectedAnswerSelector, $isCorrectAnswer }) => css`
    ${$notSelectedAnswerSelector === 'isNotSelectedAnswer' &&
    css`
      opacity: 0.3;
      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 600ms;
    `}

    ${$notSelectedAnswerSelector === 'isNotSelectedAnswer' &&
    $isCorrectAnswer &&
    css`
      color: ${COLORS.base.white};
      background-color: ${COLORS.base.green};
      border: 1px solid ${COLORS.base.green};
      transition: all 300ms cubic-bezier(0.08, 0.82, 0.17, 1);
    `}
  `}
`;
